import styled from 'styled-components';

export const LogoContainer = styled.section`
  display: flex;
`;
